const newCustomer = {
  snackbar: "Su actualización esta completada",
  name: "Nombre del Cliente",
  save: "Guardar",
  cancel: "Cancelar",
  area: "Cliente",
  formTitle: "Nuevo Cliente",
  confirm: "¿Estás seguro de querer eliminar este elemento?",
  close: "Cerrar",
  delete: "Eliminar"
};
export default newCustomer;
